The `CandidateProfile` that was purchased.

This field is only accessible while you have an active `ProactiveSourcing` relationship with the hirer.
If this relationship has been removed, it will return null along with a `FORBIDDEN` error.
